require('jquery.scrollbar');
require('./scroll/hermoso');
require('./legacy');
require('./sliders');
require('./slick-carousel');
require('./ajaxLoad');
require('./custom');